module.exports = __webpack_public_path__ + "img/onions.3c50f0c1.svg";